import { Routes } from '@angular/router';
import { UserProfileComponent } from '../../pages/user-profile/user-profile.component';
import { GestioneTipologicheComponent } from '../../pages/tipologiche/gestione-tipologiche/gestione-tipologiche.component';
import { roleGuard } from '../guard/role.guard';
import { devOnlyGuard } from '../guard/dev-only.guard';
import { RoleId } from 'src/app/pages/auth/role';

export const content: Routes = [
  {
    path: 'profilo',
    children: [
      {
        path: 'visualizza',
        component: UserProfileComponent,
        data: {
          title: 'Profilo',
          breadcrumb: 'Profilo',
        },
      },
      {
        path: 'modifica',
        component: UserProfileComponent,
        data: {
          title: 'Profilo',
          breadcrumb: 'modifica Profilo',
        },
      },
    ],
  },
  {
    path: 'anagrafiche',
    loadChildren: () => import('../../pages/anagrafiche/Utenti/utenti.module').then((m) => m.UtentiModule),
    data: {
      title: 'Utenti',
      allowedRoles: [RoleId.SA, RoleId.ADMIN],
    },
    canActivate: [roleGuard],
  },
  {
    path: 'anagrafiche/strutture',
    loadChildren: () => import('../../pages/anagrafiche/strutture/strutture.module').then((m) => m.StruttureModule),
    data: {
      title: 'Strutture',
      allowedRoles: [RoleId.SA, RoleId.ADMIN, RoleId.AM],
    },
    canActivate: [roleGuard],
  },
  {
    path: 'anagrafiche/prodotti',
    loadChildren: () => import('../../pages/anagrafiche/prodotti/prodotti.module').then((m) => m.ProdottiModule),
    data: {
      title: 'Prodotti',
      allowedRoles: [RoleId.SA, RoleId.ADMIN],
    },
    canActivate: [roleGuard],
  },
  {
    path: 'anagrafiche/segmentazioni',
    loadChildren: () =>
      import('../../pages/anagrafiche/segmentazioni-geografiche/segmentazioni-geografiche.module').then((m) => m.SegmentazioniGeograficheModule),
    data: {
      title: 'Segmentazioni',
      allowedRoles: [RoleId.SA, RoleId.ADMIN],
    },
    canActivate: [roleGuard],
  },
  {
    path: 'tipologiche',
    component: GestioneTipologicheComponent,
    data: {
      title: 'Tipologiche',
      breadcrumb: 'Tipologiche',
      allowedRoles: [RoleId.SA, RoleId.ADMIN],
    },
    canActivate: [roleGuard],
  },
  {
    path: 'anagrafiche/attivita',
    loadChildren: () => import('../../pages/anagrafiche/Attivita/attivita.module').then((m) => m.AttivitaModule),
    data: {
      title: 'Attivita',
      allowedRoles: [RoleId.SA, RoleId.ADMIN],
    },
    canActivate: [roleGuard],
  },
  {
    path: 'anagrafiche/medici',
    loadChildren: () => import('../../pages/anagrafiche/medici/medici.module').then((m) => m.MediciModule),
    data: {
      title: 'Medici',
      allowedRoles: [RoleId.SA, RoleId.ADMIN, RoleId.AM],
    },
    canActivate: [roleGuard],
  },
  {
    path: 'anagrafiche/medici/consensi-medici',
    loadChildren: () => import('../../pages/anagrafiche/consensi-medici/consensi-medici.module').then((m) => m.ConsensiMediciModule),
    data: {
      title: 'Consensi Medici',
      allowedRoles: [RoleId.SA, RoleId.ADMIN, RoleId.AM],
    },
    canActivate: [roleGuard],
  },
  {
    path: 'anagrafiche/campi-aggiuntivi',
    loadChildren: () => import('../../pages/anagrafiche/campi-aggiuntivi/campi-aggiuntivi.module').then((m) => m.CampiAggiuntiviModule),
    data: {
      title: 'Campi Aggiuntivi',
      allowedRoles: [RoleId.SA, RoleId.ADMIN],
    },
    canActivate: [roleGuard],
  },
  {
    path: 'saggi',
    loadChildren: () => import('../../pages/saggi/saggi.module').then((m) => m.SaggiModule),
    data: {
      title: 'Magazzino',
      allowedRoles: [RoleId.SA, RoleId.ADMIN, RoleId.AM],
    },
    canActivate: [roleGuard],
  },
  {
    path: 'approvazioni',
    loadChildren: () => import('../../pages/approvazioni/approvazioni.module').then((m) => m.ApprovazioniModule),
    data: {
      title: 'Approvazioni',
      allowedRoles: [RoleId.SA, RoleId.ADMIN],
    },
    canActivate: [roleGuard],
  },
  {
    path: 'cicli',
    loadChildren: () => import('../../pages/cicli/cicli.module').then((m) => m.CicliModule),
    data: {
      title: 'Cicli',
      allowedRoles: [RoleId.SA, RoleId.ADMIN, RoleId.AM],
    },
    canActivate: [roleGuard],
  },
  {
    path: 'attivita',
    loadChildren: () => import('../../pages/attività/attivita.module').then((m) => m.AttivitaPageModule),
    data: {
      title: 'Attività',
      allowedRoles: [RoleId.SA, RoleId.ADMIN, RoleId.AM],
    },
    canActivate: [roleGuard],
  },
  {
    path: 'attivita-new',
    loadChildren: () => import('../../pages/attivita-new/attivita-new.routes').then((m) => m.ATTIVITA_NEW_ROUTES),
    data: {
      title: 'Attività New',
      allowedRoles: [RoleId.SA, RoleId.ADMIN, RoleId.AM],
    },
    canActivate: [devOnlyGuard, roleGuard],
  },
  {
    path: ':token/gestione-consensi',
    loadChildren: () => import('../../pages/form-consensi/form-consensi.module').then((m) => m.FormConsensiModule),
    data: {
      title: 'Form Consensi',
      external: true,
    },
  },
  {
    path: 'approva-modifica/:token/doctor/:idDoctor/pending/:idPending',
    loadChildren: () => import('../../pages/landing-modifiche-attività/modifiche-completate.module').then((m) => m.ModificheCompletateModule),
    data: {
      title: 'Modifiche Approvate',
      external: true,
      allowedRoles: [RoleId.SA, RoleId.ADMIN],
    },
  },
  {
    path: 'rifiuta-modifica/:token/doctor/:idDoctor/pending/:idPending',
    loadChildren: () => import('../../pages/landing-modifiche-attività/modifiche-completate.module').then((m) => m.ModificheCompletateModule),
    data: {
      title: 'Modifiche Rifiutate',
      external: true,
      allowedRoles: [RoleId.SA, RoleId.ADMIN],
    },
  },
  {
    path: 'presenze',
    loadChildren: () => import('../../pages/presenze/presenze.module').then((m) => m.PresenzeModule),
    data: {
      title: 'Presenze',
      allowedRoles: [RoleId.SA, RoleId.ADMIN, RoleId.AM],
    },
    canActivate: [roleGuard],
  },
  {
    path: 'note-spese',
    loadChildren: () => import('../../pages/note-spese/note-spese.module').then((m) => m.NoteSpeseModule),
    data: {
      title: 'Note Spese',
      allowedRoles: [RoleId.SA, RoleId.ADMIN, RoleId.AM],
    },
    canActivate: [roleGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () => import('../../pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
    data: {
      title: 'Dashboard',
      allowedRoles: [RoleId.AM],
    },
  },
  {
    path: 'report',
    loadChildren: () => import('../../pages/report/report.module').then((m) => m.ReportModule),
    data: {
      title: 'Report'
    },
  },
];
